import React, { useCallback } from "react";
import {
  ActionCreatorWithoutPayload,
  ActionCreatorWithPayload,
} from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import { useJwtExpiry } from "../hooks/useJwtExpiry";
import useRefreshAuthMutation from "../hooks/useRefreshAuth";

interface JwtProviderProps {
  children: React.ReactNode;
  tokenSelector: (state: any) => { token: string };
  resetAuthAction: ActionCreatorWithoutPayload<string>;
  setTokenAction: ActionCreatorWithPayload<{ token: string }, string>;
}

const JwtProviderComponent: React.FC<JwtProviderProps> = ({
  children,
  tokenSelector,
  resetAuthAction,
  setTokenAction,
}) => {
  const refreshAuthMutation = useRefreshAuthMutation(setTokenAction);
  const { token } = useSelector(tokenSelector);

  const handleTokenRefresh = useCallback(async () => {
    await refreshAuthMutation.mutateAsync({ token });
  }, [refreshAuthMutation, token]);

  useJwtExpiry(tokenSelector, resetAuthAction, handleTokenRefresh);
  return <>{children}</>;
};

// Memoize to prevent unnecessary remounts during navigation
export const JwtProvider = React.memo(JwtProviderComponent);
